import React from 'react'

import Base from '../_Base'

const BrazilA10 = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <g clipPath="url(#brazil_a10)">
      <rect width="24" height="24" rx="2" fill="#0095DA" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.133 10.087v3.81c0 1.178-.182 1.995-.545 2.448-.363.454-.998.68-1.91.68-.924 0-1.565-.226-1.922-.674-.357-.448-.539-1.264-.539-2.455v-3.81c0-1.184.182-2 .539-2.443.357-.447.998-.669 1.922-.669.918 0 1.553.222 1.916.67.357.447.538 1.258.538 2.443Zm-1.968-.726c0-.487-.034-.805-.107-.964-.068-.158-.199-.232-.38-.232-.182 0-.306.085-.38.255-.074.17-.108.488-.108.941v5.26c0 .505.034.829.108.976.068.147.198.221.385.221.176 0 .3-.085.375-.25.073-.164.107-.481.107-.952V9.361ZM11.906 7.07h1.684v9.933h-1.922V9.622c-.164.17-.346.317-.544.448-.198.13-.408.232-.64.311v-1.78a3.54 3.54 0 0 0 .872-.674 2.83 2.83 0 0 0 .55-.856ZM7.178 13.454H6.72l.46-4.059.458 4.06h-.459Zm1.945-6.338H5.228l-1.36 9.887h2.726l.153-1.809h.862l.153 1.809h2.721l-1.36-9.887Z"
        fill="#fff"
      />
    </g>
    <rect x=".5" y=".5" width="23" height="23" rx="1.5" stroke="#fff" />
    <defs>
      <clipPath id="brazil_a10">
        <rect width="24" height="24" rx="2" fill="#fff" />
      </clipPath>
    </defs>
  </Base>
)

export default BrazilA10
